export default "__VITE_PUBLIC_ASSET__a02d94bd__"